import { ENDPOINTS } from 'src/constants/endpoints'

import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import type { IDocumentUpdateEntity } from '../../types'
import type { IFundUpdateItemDTO } from '../contracts/fund-updates'

const removePdfExtension = (fileName: string): string => {
  return fileName.replace(/\.pdf$/i, '')
}

export const mapFundUpdateItem = (
  dto: IFundUpdateItemDTO,
): IDocumentUpdateEntity => {
  return {
    id: dto.id,
    documentTitle: removePdfExtension(dto.file_name),
    category: dto.category,
    categoryDisplayLabel: dto.category,
    releaseDate: dto.release_date,
    displayDate: DateAdapter.formatReleaseDate(dto.release_date),
    documentUrl: ENDPOINTS.hanwha.fundUpdateDownload(dto.id),
  }
}
